export enum SecureWebhookTypes {
    BASIC = "Basic",
    OAUTH = "Oauth",
    NONE = "None",
}